import React from "react";
import RegistrationForm from "./RegistrationForm";
import RegisterCourse from "./RegisterCourse";
import Footer from "../../../Components/Footer/Footer";
import { ui_ux_data } from "../ServicesDisplayPage/servicesData";

const Register_ui = () => {
  const page_data = {
    data: ui_ux_data,
    title: "UI/UX Development",
    description: "Master modern UI/UX design principles and tools",
    amount: 2000, // adjust if needed
  };

  return (
    <>
      {/* Registration Form instead of Hero */}
      <RegistrationForm page_data={page_data} />

      {/* Service Body (course details/steps) */}
      <RegisterCourse service_steps={page_data} />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Register_ui;
